module.exports = __webpack_public_path__ + "static/media/about-tata-cliq.9c184546.png";